/**
 * The password rule auth.new_password_validation_message describes: 8–256
 * characters with an upper- and lower-case letter, a digit and a symbol.
 */
export const strongPassword =
  /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[\^$*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ])[A-Za-z0-9^$*.[\]{}()?"!@#%&/\\,><':;|_~`=+\- ]{8,256}$/;
